<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/materialoutbound/add')">新增</el-button>
        <el-button type="primary" v-if="hasExport" @click="onExport">导出</el-button>
      </template>
      <el-form :model="searchForm" ref="searchForm" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item label="物料名称" prop="materialName">
          <el-input clearable v-model.trim="searchForm.materialName" placeholder="请输入物料名称" />
        </el-form-item>
        <el-form-item label="开始日期" prop="startTime">
          <el-date-picker v-model="searchForm.startTime" type="date" value-format="yyyy-MM-dd"
            placeholder="请选择开始日期" />
        </el-form-item>
        <el-form-item label="结束日期" prop="endTime">
          <el-date-picker v-model="searchForm.endTime" type="date" value-format="yyyy-MM-dd"
            placeholder="请选择结束日期" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="140" label="领用日期" prop="outboundDate">
          <template v-slot="{ row }">
            {{ formatDate(row.outboundDate) }}
          </template>
        </el-table-column>
        <el-table-column min-width="160" :show-overflow-tooltip="true" label="物料名称" prop="materialName"></el-table-column>
        <el-table-column min-width="160" :show-overflow-tooltip="true" label="生产日期及批号" prop="productionDateBatchNo"></el-table-column>
        <el-table-column min-width="160" :show-overflow-tooltip="true" label="生产厂家" prop="manufacturerName"></el-table-column>
        <el-table-column min-width="160" :show-overflow-tooltip="true" label="保质期" prop="shelfLife"></el-table-column>
        <el-table-column min-width="140" label="到货日期" prop="arrivalDate">
          <template v-slot="{ row }">
            {{ formatDate(row.arrivalDate) }}
          </template>
        </el-table-column>
        <el-table-column min-width="160" :show-overflow-tooltip="true" label="出库数量" prop="outboundQuantity"></el-table-column>
        <el-table-column min-width="160" :show-overflow-tooltip="true" label="出库原因" prop="outboundReason"></el-table-column>
        <el-table-column min-width="160" :show-overflow-tooltip="true" label="领用人" prop="receiverUserName"></el-table-column>
        <el-table-column width="160" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.push('/materialoutbound/detail?outboundId=' + row.outboundId)">详情</el-button>
            <el-button type="text" v-if="hasEdit" @click="$router.push('/materialoutbound/edit?outboundId=' + row.outboundId)">编辑</el-button>
            <el-button class="del-btn" type="text" v-if="hasDelete" @click="deleteRow(row.outboundId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import keepAlive from '@/mixins/keepAlive'
import { exportFiles } from '@/utils/globalMethods'

export default {
  name: 'MaterialOutbound',
  mixins: [keepAlive],
  data() {
    return {
      tableData: [],
      page: 1,
      total: 0,
      loading: false,
      searchForm: {
        materialName: '',
        startTime: '',
        endTime: ''
      }
    }
  },
  created() {
    this.loadData()
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasDelete() {
      return this.buttonList.includes('delete')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasExport() {
      return this.buttonList.includes('export')
    }
  },
  methods: {
    formatDate(value, format = 'YYYY-MM-DD') {
      return value ? dayjs(value).format(format) : '--'
    },
    loadData() {
      const { startTime, endTime } = this.searchForm
      if (startTime && endTime && startTime > endTime) {
        this.$message.warning('开始日期不能晚于结束日期')
        return
      }
      this.loading = true
      return this.$axios.get(this.$apis.prodManage.selectScMaterialOutboundByPage, {
        page: this.page,
        size: 10,
        ...this.searchForm,
        startTime: startTime ? startTime + ' 00:00:00' : '',
        endTime: endTime ? endTime + ' 23:59:59' : ''
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).catch(() => {
        // 请求错误由全局拦截器提示。
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      return this.loadData()
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      return this.onSearch()
    },
    onExport() {
      const { startTime, endTime } = this.searchForm
      if (startTime && endTime && startTime > endTime) {
        this.$message.warning('开始日期不能晚于结束日期')
        return
      }
      // 导出与列表使用同一时间边界，确保结束日期当天的数据不会被遗漏。
      exportFiles(this.$apis.prodManage.exportMaterialOutbound, {
        ...this.searchForm,
        startTime: startTime ? startTime + ' 00:00:00' : '',
        endTime: endTime ? endTime + ' 23:59:59' : ''
      })
    },
    deleteRow(outboundId) {
      return this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return this.$axios.post(this.$apis.prodManage.deleteScMaterialOutbound, {
          outboundId
        })
      }).then(() => {
        if (this.tableData.length === 1 && this.page > 1) {
          this.page -= 1
        }
        return this.loadData()
      }).catch(() => {
        // 取消删除无需处理，请求错误由全局拦截器提示。
      })
    }
  }
}
</script>

<style scoped lang="scss">
.account-form {
  .el-select,
  .el-input,
  .el-cascader {
    width: 200px !important;
  }
}
</style>
